import { OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ConfigService } from '../../services/config/config.service';
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(authService, configService, termsAndConditionsService) {
        this.authService = authService;
        this.configService = configService;
        this.termsAndConditionsService = termsAndConditionsService;
        this.isIframe = false;
        this.currentUser = null;
        this.destroy$ = new Subject();
        this.productName = this.configService.config.productName;
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.initMSAL();
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (user) {
            _this.currentUser = user;
        });
    };
    HomeComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    Object.defineProperty(HomeComponent.prototype, "isLoginInProgress", {
        get: function () {
            return this.authService.isLoginInProgress;
        },
        enumerable: true,
        configurable: true
    });
    HomeComponent.prototype.login = function () {
        this.authService.login();
    };
    HomeComponent.prototype.logout = function () {
        this.authService.logout();
    };
    HomeComponent.prototype.isLoggedIn = function () {
        return !!this.currentUser;
    };
    Object.defineProperty(HomeComponent.prototype, "mustAgree", {
        get: function () {
            return this.termsAndConditionsService.canAgreeToTermsAndConditions && !!this.currentUser;
        },
        enumerable: true,
        configurable: true
    });
    HomeComponent.prototype.showTermsAndConditions = function () {
        this.termsAndConditionsService.show();
    };
    HomeComponent.prototype.isInRole = function (role) {
        return !!this.currentUser && this.currentUser.isInRole(role);
    };
    HomeComponent.prototype.showUsageReports = function () {
        return !!this.currentUser &&
            this.currentUser.isInRole('jjr') && this.currentUser.hasAdminRole;
    };
    return HomeComponent;
}());
export { HomeComponent };
